import { render, staticRenderFns } from "./DragPlaceholder.vue?vue&type=template&id=8f2066d6&"
import script from "./DragPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./DragPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports